/* ClassyTea Wave 3 homepage (ct-home), 2026-09-23.
   Ported from the Claude Design handoff script. Kept: band fade-in, parallax
   grounds (Fragonard, storefront), room photos drifting in frames, reviews loop.
   Dropped (live theme owns them, ruling D1): announcement rotator, reveal-header
   clone, menu drawer.
   Rules (Optimization Toolbelt): passive listeners, rAF-batched paint, all motion
   off under prefers-reduced-motion, safe to load more than once (every ct-home
   section renders this tag; the guard below makes it run once). */
(function(){
  if (window.__ctHome) return; window.__ctHome = true;
  var reduce = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  var EASE='cubic-bezier(.16,1,.3,1)';

  function bands(){ return [].slice.call(document.querySelectorAll('.ct-home > [data-band]')); }

  /* 1 · fade-in per band. The hero is skipped: it is on screen at load and holds the LCP image. */
  function fadeIn(){
    if (reduce || !('IntersectionObserver' in window)) return;
    bands().forEach(function(band){
      if (band.getAttribute('data-band')==='hero') return;
      var kids=[].slice.call(band.querySelectorAll(':scope > *, :scope > div > *')).filter(function(el){
        var cs=getComputedStyle(el); return cs.position!=='absolute' && cs.position!=='fixed';
      }).slice(0,4);
      var targets=kids.length?kids:[band];
      targets.forEach(function(el,i){
        if(el.hasAttribute('data-om-anim')) return;
        el.setAttribute('data-om-anim','');
        el.style.opacity='0';
        el.style.transform='translateY(18px)';
        el.style.transition='opacity 760ms '+EASE+' '+(i*90)+'ms, transform 760ms '+EASE+' '+(i*90)+'ms';
      });
      var io=new IntersectionObserver(function(entries){
        entries.forEach(function(e){ if(!e.isIntersecting) return; targets.forEach(function(el){ el.classList.add('om-in'); }); io.disconnect(); });
      },{rootMargin:'0px 0px -12% 0px',threshold:0.05});
      io.observe(band);
    });
    /* safety net: never leave anything invisible */
    setTimeout(function(){ [].slice.call(document.querySelectorAll('.ct-home [data-om-anim]')).forEach(function(el){ if(getComputedStyle(el).opacity==='0' && el.getBoundingClientRect().top < window.innerHeight) el.classList.add('om-in'); }); },2500);
  }

  /* 2 · parallax: painted/photo grounds drift behind their band; room photos drift inside their frames */
  function parallax(){
    if (reduce) return;
    var grounds=[].slice.call(document.querySelectorAll('.ct-home [data-px-ground], .ct-home [data-proof]'));
    var framed=[].slice.call(document.querySelectorAll('.ct-home [data-g3="room"] img'));
    grounds.forEach(function(el){ el.setAttribute('data-px',''); });
    framed.forEach(function(el){ el.setAttribute('data-pxi',''); });
    if(!grounds.length && !framed.length) return;
    var queued=false;
    function prog(r){ return Math.max(0,Math.min(1,(window.innerHeight-r.top)/(window.innerHeight+r.height))); }
    function paint(){
      queued=false;
      grounds.forEach(function(el){
        var r=el.getBoundingClientRect();
        if(r.bottom<-200||r.top>window.innerHeight+200) return;
        var ar=parseFloat(el.getAttribute('data-px-ar')||'0.7958'); /* painting width/height; the Swing is 955×1200 */
        el.style.setProperty('--py',(prog(r)*100).toFixed(2)+'%');
        el.style.setProperty('--pw',Math.ceil(Math.max(r.width,r.height*1.6*ar))+'px');
      });
      framed.forEach(function(el){
        var r=el.parentNode.getBoundingClientRect();
        if(r.bottom<-200||r.top>window.innerHeight+200) return;
        el.style.setProperty('--iy',((prog(r)-0.5)*-12).toFixed(2)+'%');
      });
    }
    function queue(){ if(!queued){ queued=true; requestAnimationFrame(paint); } }
    window.addEventListener('scroll',queue,{passive:true});
    window.addEventListener('resize',queue,{passive:true});
    queue();
  }

  /* 3 · reviews: loop the cards on phones (auto-scroll pauses 3.5 s on any touch) */
  function revRail(){
    var g=document.querySelector('.ct-home [data-rev-grid]');
    if(!g) return;
    if(!g.hasAttribute('data-rev-looped')){
      g.setAttribute('data-rev-looped','');
      [].slice.call(g.children).forEach(function(c){ var k=c.cloneNode(true); k.setAttribute('data-rev-clone',''); k.setAttribute('aria-hidden','true'); [].slice.call(k.querySelectorAll('a,button')).forEach(function(a){ a.setAttribute('tabindex','-1'); }); g.appendChild(k); });
    }
    if(reduce) return;
    var on=false, paused=0, speed=0.35, acc=0;
    var io=new IntersectionObserver(function(es){ es.forEach(function(e){ on=e.isIntersecting; }); },{rootMargin:'0px 0px -50% 0px'});
    io.observe(g);
    function hold(){ paused=Date.now()+3500; g.style.scrollSnapType=''; }
    ['pointerdown','touchstart','wheel','mouseenter','focusin'].forEach(function(ev){ g.addEventListener(ev,hold,{passive:true}); });
    setInterval(function(){
      if(!on || window.innerWidth>767 || Date.now()<paused) return;
      g.style.scrollSnapType='none';
      acc+=speed; var step=Math.floor(acc); if(!step) return; acc-=step;
      var clone=g.querySelector('[data-rev-clone]'), period=clone ? clone.offsetLeft - g.children[0].offsetLeft : g.scrollWidth/2;
      var next=g.scrollLeft+step; if(next>=period) next-=period;
      g.scrollLeft = next;
    },16);
  }

  /* 4 · background grounds (Fragonard, storefront): request the image only when the band is within
        1250px of the screen, the same distance Chrome uses for loading="lazy" on fast connections
        (web.dev, browser-level lazy loading). CSS backgrounds cannot use loading="lazy". */
  function lazyGrounds(){
    var els=[].slice.call(document.querySelectorAll('.ct-home [data-ct-lazybg]:not(.ct-bg-on)'));
    if(!els.length) return;
    if(!('IntersectionObserver' in window)){ els.forEach(function(el){ el.classList.add('ct-bg-on'); }); return; }
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('ct-bg-on'); io.unobserve(e.target); } });
    },{rootMargin:'1250px 0px 1250px 0px'});
    els.forEach(function(el){ io.observe(el); });
  }

  /* Swipe rails (New arrivals, reviews, journal): the PDP rule is "carousels load every slide, at low priority, so a swipe
     never lands on a blank frame" (Toolbelt A5). These rails sit far below the first screen, so they wait until the band is
     within 1250 px (the browser's own lazy distance), then every slide in the rail loads at once, still at low priority.
     Without JS the images are plain loading="lazy" and the browser handles them. */
  function warmRails(){
    var rails=[].slice.call(document.querySelectorAll('.ct-home [data-rail]:not([data-ct-warm]), .ct-home [data-rev-grid]:not([data-ct-warm]), .ct-home [data-journal]:not([data-ct-warm])'));
    if(!rails.length) return;
    function warm(r){ r.setAttribute('data-ct-warm',''); [].forEach.call(r.querySelectorAll('img[loading="lazy"]'),function(i){ i.loading='eager'; }); }
    if(!('IntersectionObserver' in window)){ rails.forEach(warm); return; }
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ warm(e.target); io.unobserve(e.target); } });
    },{rootMargin:'1250px 0px 1250px 0px'});
    rails.forEach(function(r){ io.observe(r); });
  }

  function init(){ lazyGrounds(); warmRails(); fadeIn(); parallax(); revRail(); }
  /* Theme editor re-renders a section in place; DOMContentLoaded will not fire again (Toolbelt E1). */
  document.addEventListener('shopify:section:load',function(){ lazyGrounds(); warmRails(); parallax(); revRail(); });
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
